import memberReducer from './memberReducer';

export default memberReducer;